import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand Section */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">FormBridge</h3>
            <p className="text-gray-600 text-sm">
              Transform complex PDF forms into user-friendly web interfaces. 
              Accessible, multilingual and AI-powered.
            </p>
          </div>

          {/* Links Section */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Features</h4>
            <ul className="space-y-2 text-sm text-gray-600">
              <li>• PDF Upload & Analysis</li>
              <li>• Automatic Translation</li>
              <li>• AI-assisted Form Filling</li>
              <li>• Accessible Operation</li>
            </ul>
          </div>

          {/* Accessibility Info */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Accessibility</h4>
            <p className="text-sm text-gray-600">
              This application follows WCAG 2.1 AA standards for digital accessibility.
            </p>
            <div className="mt-4 flex space-x-4">
              <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded">
                Screen Reader
              </span>
              <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
                Keyboard Navigation
              </span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-500">
            © 2025 FormBridge. Built for digital inclusion.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <button className="text-sm text-gray-500 hover:text-gray-700">
              Privacy
            </button>
            <button className="text-sm text-gray-500 hover:text-gray-700">
              Legal Notice
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;